import { slotObjectToDataTestIds } from '@elliemae/ds-system';
export const DSButtonName = 'DSButton';

export const DSButtonSlots = {
  ROOT: 'root',
} as const;

export const DSButtonDataTestId = {
  ...(slotObjectToDataTestIds(DSButtonName, DSButtonSlots) as Record<keyof typeof DSButtonSlots, string>),
  ROOT: 'ds-button',
};
